// reducers
function myaccount(state = {}, action) {
  switch (action.type) {
    case 'MYACCOUNT_DATA_SUCCESS':
      return action.myaccount;

    default:
      return state;
  }
}

export default myaccount;
